import React, { Component } from 'react';
import Filter from './Filter';

class Influence extends Component {

  render() {
    return (
      <section id="the-influence-section">
        <div className="container">
          <div className="row header-row">
            <div className="col12">
              <h2>The Influence.</h2>
            </div>
          </div>
          <div className="row copy-row">
            <div className="copy-col">
              <h3>Health Effects</h3>
              <h4>The influence of drugs and alcohol last longer than the immediate effect. After the initial effects wear off there can be a lasting impact.</h4>
            </div>
          </div>
          <div className="row">
            <div className="filter-col">
              <Filter />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Influence;



// WEBPACK FOOTER //
// ./src/components/Influence/Influence.js